export const getYarraValleyData = () => ({
  name: "Yarra Valley",
  country: "Australie",
  description: "La Yarra Valley est une région viticole prestigieuse du Victoria, réputée pour ses vins frais et élégants. Son climat tempéré et ses influences océaniques créent des conditions idéales pour des vins de grande finesse, notamment les Pinot Noir et Chardonnay.",
  type: "region",
  mapAreas: [
    { region: "Yarra Valley", x: 65, y: 70, color: "#c486c4", size: 3 }
  ],
  statistics: {
    totalArea: "5,000 ha",
    production: "0.3 million hectolitres",
    appellations: "Yarra Valley GI",
    subregions: "4 sous-régions principales",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat tempéré avec influence océanique, étés chauds, hivers froids, précipitations régulières",
    soil: "Sols volcaniques, argileux, sableux, excellente diversité géologique",
    viticulture: "Viticulture moderne, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Pinot Noir élégants et complexes, Cabernet Sauvignon structurés, Shiraz frais",
    white: "Chardonnay frais et complexes, Sauvignon Blanc aromatiques, Sémillon élégants",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle, spécialité régionale"
  },
  history: "La viticulture dans la Yarra Valley remonte aux années 1830. La région s'est imposée comme l'une des plus prestigieuses d'Australie, reconnue pour ses vins frais et élégants, notamment les Pinot Noir.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes blanches, fromages affinés, cuisine fusion.",
  subregions: {
    "upper-yarra-valley": {
      name: "Upper Yarra Valley",
      description: "Zone d'altitude, réputée pour ses Pinot Noir élégants et ses Chardonnay complexes.",
      characteristics: {
        climate: "Plus frais, altitude élevée",
        soil: "Sols volcaniques et argileux",
        viticulture: "Vignobles modernes, altitude élevée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "pinot-noir": "Rouges élégants et complexes",
        "chardonnay": "Blancs frais et aromatiques"
      },
      foodPairing: "Poissons, volailles, fromages affinés"
    },
    "lower-yarra-valley": {
      name: "Lower Yarra Valley",
      description: "Zone plus chaude, connue pour ses vins rouges structurés et ses blancs aromatiques.",
      characteristics: {
        climate: "Tempéré, influence océanique",
        soil: "Sols argileux et sableux",
        viticulture: "Vignobles historiques, rendements limités"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
        red: ["Cabernet Sauvignon", "Shiraz", "Pinot Noir"]
      },
      wineStyles: {
        "rouge": "Rouges structurés et équilibrés",
        "blanc": "Blancs aromatiques et complexes"
      },
      foodPairing: "Viandes rouges, volailles, cuisine traditionnelle"
    },
    "coldstream": {
      name: "Coldstream",
      description: "Zone fraîche, réputée pour ses vins blancs frais et ses rouges élégants.",
      characteristics: {
        climate: "Frais, influence océanique",
        soil: "Sols volcaniques et argileux",
        viticulture: "Vignobles modernes, climat frais"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Sémillon"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "blanc": "Blancs frais et tendus",
        "rouge": "Rouges élégants et fruités"
      },
      foodPairing: "Poissons, volailles, cuisine légère"
    },
    "gruyere": {
      name: "Gruyere",
      description: "Zone émergente, connue pour ses vins rouges fruités et ses blancs aromatiques.",
      characteristics: {
        climate: "Tempéré, influence océanique",
        soil: "Sols argileux et sableux",
        viticulture: "Vignobles modernes, expérimentation variétale"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "rouge": "Rouges fruités et accessibles",
        "blanc": "Blancs aromatiques et frais"
      },
      foodPairing: "Viandes rouges, volailles, cuisine moderne"
    }
  }
}); 